/**
 * Copy + option lists for path settings (Voluum panel parity).
 * For Media Devoted | Created By Ciro Autiero
 */

import type {
  VoluumAutoOptimizationMode,
  VoluumCalculationMethod,
  VoluumOfferRedirectMode,
} from '@trafficpulse/shared';

export type PathDestinationMode = 'LANDERS_AND_OFFERS' | 'OFFERS_ONLY';

export interface PathSettingPillOption<T extends string> {
  value: T;
  label: string;
  description?: string;
}

export const PATH_DESTINATION_OPTIONS: PathSettingPillOption<PathDestinationMode>[] =
  [
    {
      value: 'LANDERS_AND_OFFERS',
      label: 'Landers & offers',
      description:
        'Visitors hit a lander before the offer (classic funnel). Add landers below.',
    },
    {
      value: 'OFFERS_ONLY',
      label: 'Offers only',
      description:
        'No lander step on this path — traffic goes straight to offers. Clears existing landers when selected.',
    },
  ];

export const PATH_TRANSITION_OPTIONS: PathSettingPillOption<VoluumOfferRedirectMode>[] =
  [
    {
      value: 'REGULAR',
      label: '302',
      description:
        'Classic HTTP redirect chain between lander and offer (302-style Location hops).',
    },
    {
      value: 'HTML',
      label: 'Meta refresh',
      description: 'HTML / meta refresh handoff from lander to offer.',
    },
    {
      value: 'DOUBLE_HTML',
      label: 'Double meta refresh',
      description: 'Two meta refresh transitions before the offer.',
    },
    {
      value: 'REDIRECTLESS',
      label: 'Direct',
      description:
        'Minimal redirect hops; offer opens without a classic redirect sequence where Voluum allows it.',
    },
  ];

export const PATH_AUTO_MODE_OPTIONS: PathSettingPillOption<VoluumAutoOptimizationMode>[] =
  [
    {
      value: 'OFFER',
      label: 'Offers',
      description: 'Optimize offer weights only.',
    },
    {
      value: 'LANDER',
      label: 'Landers',
      description: 'Optimize lander weights only.',
    },
    {
      value: 'INDEPENDENT',
      label: 'Both separately',
      description: 'Optimize landers and offers independently.',
    },
    {
      value: 'DEPENDENT',
      label: 'Both combined',
      description: 'Optimize landers and offers together (dependent mode).',
    },
  ];

export const CALCULATION_METHODS: VoluumCalculationMethod[] = [
  'AUTO',
  'ROI',
  'EPV',
  'CVR',
];

export const CALCULATION_METHOD_LABEL: Record<VoluumCalculationMethod, string> =
  {
    AUTO: 'Auto',
    ROI: 'ROI',
    EPV: 'EPV',
    CVR: 'CVR',
  };
